import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type InvoiceData} from './invoice';

export function invoicePatcher(data: InvoiceData): RestTypeWithTypename<InvoiceData> {
    return {
        __typename: 'InvoiceData',
        behaviors: data.behaviors.map(b => ({
            ...b,
            __typename: 'invoiceBehavior',
            payload: b.payload ? {__typename: 'invoiceBehaviorPayload', ...b.payload} : null,
        })),
        billPayers: data.billPayers.map(b => ({
            ...b,
            __typename: 'invoiceBillPayer',
            shares: {...b.shares, __typename: 'invoiceBillPayerShares'},
        })),
        invoices: data.invoices.map(i => ({__typename: 'invoice', ...i})),
    };
}
